import { cn } from '@/lib/utils';
import { FunctionComponent, useRef } from 'react';
import { Tooltip } from 'react-tooltip';
import useOverflow from './useOverflow';

interface EllipsizedWithTooltipProps {
  elementText: string;
  tooltipText: string;
  id: string;
  className?: string;
}

const EllipsizedWithTooltip: FunctionComponent<EllipsizedWithTooltipProps> = ({
  elementText,
  tooltipText,
  id,
  className
}) => {
  const textRef = useRef<HTMLDivElement>(null);
  const isOverflowing = useOverflow(textRef);

  return (
    <div ref={textRef} className={cn('whitespace-nowrap overflow-hidden text-ellipsis', className)}>
      {isOverflowing ? <a data-tooltip-id={`${id}Tooltip`}>{elementText}</a> : elementText}
      <Tooltip id={`${id}Tooltip`} className="max-w-[400px] z-50 text-center break-words whitespace-normal">
        {tooltipText}
      </Tooltip>
    </div>
  );
};

export default EllipsizedWithTooltip;
